import { useRef, useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { getDeviceCarriersList } from "../../services/deviceService";
import { deviceCarriersState } from "../../storage/devices";


function DeviceCarrierProvider() {
  const setDeviceCarriers = useSetRecoilState(deviceCarriersState);
  const requestIdRef = useRef(0);

  useEffect(() => {
    const loadDevicesCarriers = async () => {
      const requestId = ++requestIdRef.current;
      const { carriers, error } = await getDeviceCarriersList();
      if (requestId === requestIdRef.current) {
        if (!error && carriers) {
          setDeviceCarriers(carriers);
        } else {
          setDeviceCarriers(undefined)
        }
      }
    };
    loadDevicesCarriers();
  }, []);

  return null;
}

export default DeviceCarrierProvider;
